<template>
  <div class="layer">
    <div class="contrast">
      <div class="contrast-header width">
        <el-input clearable v-model="keyword" placeholder="输入对比关键词"></el-input>
        <el-button @click="contrast" type="primary" style="margin-left:30px" :loading='loading1'>对比</el-button>
      </div>
      <div class="contrast-echart width" >
        <div class="contrast-chart" v-loading='loading1' style="height:300px">
          <wordcloud-Chart
            v-if="Object.keys(simkeywordsList).length"
            style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
            :WordCloudList="simkeywordsList"
            id="CNChart"
            height="100%"
            width="100%"
            tit="中文关联关键词"
          />
          <div v-else style="display:flex;height: 100%;">
            <span style="margin:auto;font-size: 20px;">暂无该关键词中文关联领域</span>
          </div>
        </div>
        <div class="contrast-chart" v-loading='loading1' style="height:300px">
          <wordcloud-Chart
            v-if="Object.keys(keyEnCList).length"
            style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
            :WordCloudList="keyEnCList"
            id="CNChart"
            height="100%"
            width="100%"
            tit="英文关联关键词"
          />
          <div v-else style="display:flex;height: 100%;">
            <span style="margin:auto;font-size: 20px;" >暂无该关键词英文关联领域</span>
          </div>
        </div>
        <div class="contrast-chart" v-loading='loading2' style="height:300px">
          <wordcloud-Chart
            v-if="Object.keys(SCIList).length"
            style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
            :WordCloudList="SCIList"
            id="CNChart"
            height="100%"
            width="100%"
            tit="SCI关联关键词"
          />
          <div v-else style="display:flex;height: 100%;">
            <span style="margin:auto;font-size: 20px;" >暂无该关键词SCI关联关键词</span>
          </div>
        </div>
      </div>
      <div class="contrast-echartwidth">
        <div class="contrast-chart" v-loading='loading1'>
          <el-table :data="simkeywordsList"  border style="width: 100%">
            <el-table-column prop="name" label="关键词" ></el-table-column>
            <el-table-column prop="count" label="次数"></el-table-column>
          </el-table>
        </div>
        <div class="contrast-chart" v-loading='loading1'>
          <el-table :data="keyEnCList"  border style="width: 100%">
            <el-table-column prop="name" label="关键词" ></el-table-column>
            <el-table-column prop="count" label="次数" ></el-table-column>
          </el-table>
        </div>
        <div class="contrast-chart" v-loading='loading2'>
          <el-table :data="SCIList"  border style="width: 100%">
            <el-table-column prop="name" label="关键词" ></el-table-column>
            <el-table-column prop="count" label="次数"></el-table-column>
          </el-table></div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from '@/components/Charts/PieChart'
import WordcloudChart from '@/components/Charts/WordcloudChart'
import { searchCoreKeywordsv2, searchSCI, getKeywordTranslate } from '@/api/contrast'
export default {
  name: 'Contrast',
  data () {
    return {
      keyword: '',
      simkeywordsList: [],
      keyEnCList: [],
      SCIList: [],
      loading1: false,
      loading2: false
    }
  },
  components: {
    PieChart,
    WordcloudChart
  },
  methods: {
    contrast () {
      this.loading1 = true
      this.loading2 = true
      this.keyEnCList = []
      this.simkeywordsList = []
      this.SCIList = []
      let data = {
        keyword: this.keyword
      }
      searchCoreKeywordsv2(data).then(res => {
        this.simkeywordsList = res.data.data.cnkeyword.map(it => {
          return {
            name: it.key,
            count: it.doc_count
          }
        })
        this.keyEnCList = res.data.data.enkeyword.map(it => {
          return {
            name: it.key,
            count: it.doc_count
          }
        })
        this.loading1 = false
      })
      getKeywordTranslate({k: this.keyword}).then(res => {
        let temp = res.data.data.map(it => {
          return it.keyEn
        })
        this.getSCI(temp)
      })
    },
    getSCI (key) {
      searchSCI({keyword: key}).then(res => {
        this.SCIList = res.data.map(it => {
          return {
            name: it.key,
            count: it.doc_count
          }
        })
        this.loading2 = false
      })
    }
  }
}
</script>

<style lang="scss">
.contrast{
  padding-top: 40px;
  width: 92vw;
  .contrast-header{
    padding: 40px;
    background: #fff;
    display: flex;
    flex-direction: row;
    .el-input{
      width: 30%;
    }
  }
  .contrast-echart{
    background: #fff;
    padding: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .contrast-chart{
      margin-right: 2%;
      width: 30%;

    }

  }
}
</style>



// WEBPACK FOOTER //
// src/view/Contrast.vue